import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLiveOAuthClient } from './auth/live-session.js';

export function OAuthCallbackRoute() {
  const navigate = useNavigate();
  const [error, setError] = useState<string>();

  useEffect(() => {
    let active = true;
    void getLiveOAuthClient()
      .then((client) => client.completeAuthorization(globalThis.location.href))
      .then(() => {
        if (!active) return undefined;
        return navigate('/', { replace: true });
      })
      .catch((reason: unknown) => {
        if (active) {
          setError(reason instanceof Error ? reason.message : 'OAuth callback failed.');
        }
      });

    return () => {
      active = false;
    };
  }, [navigate]);

  if (error !== undefined) {
    return (
      <main className="shell">
        <section className="panel">
          <h1>Sign-in failed</h1>
          <p role="alert">{error}</p>
          <a href="/">Return to InfraHub</a>
        </section>
      </main>
    );
  }

  return (
    <main className="shell">
      <section className="panel">
        <h1>Completing sign-in</h1>
        <p>Validating the authorization response.</p>
      </section>
    </main>
  );
}

export function SignedOutRoute() {
  return (
    <main className="shell">
      <section className="panel">
        <h1>Signed out</h1>
        <p>Your local InfraHub session is cleared.</p>
        <a href="/">Return to InfraHub</a>
      </section>
    </main>
  );
}
